export default __webpack_public_path__ + "static/media/app-store-badge-us-black.660521a5.svg";